import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Map, List } from 'immutable';

import InlineEditor from '../../types/InlineEditor';
import { getComponent } from '../../types/Components';

import { RelationshipActions } from '../../../actions/relationship';
import { InlineEditorActions } from '../../../actions/inlineEditor';

import { validateAndDispatch } from '../../..//helpers/form';
// import '../styles/Element.css';

class RelationshipProps extends Component {
  static propTypes = {
    relationship: PropTypes.instanceOf(Map),
    relationshipTypes: PropTypes.instanceOf(Map),
    clearPartitions: PropTypes.func,
    dispatch: PropTypes.func,
  };

  updateRelationshipPropValue = relationshipProp => {
    const { dispatch, relationship, clearPartitions } = this.props;
    const currentRelationshipId = relationship.get('id');

    const propKey = Object.keys(relationshipProp)[0];
    const formUid = `relationship-${currentRelationshipId}-${propKey}`;

    const options = {
      props: relationshipProp,
    };

    const action = RelationshipActions.updateProperty(
      currentRelationshipId,
      options,
    );

    const validation = {};

    return validateAndDispatch(
      dispatch,
      action,
      validation,
      relationshipProp,
    ).then(() => {
      dispatch(InlineEditorActions.unsetInlineEditState(formUid));
      if (clearPartitions) clearPartitions();
    });
  };

  fieldSet = (propKey, val, relId, index) => {
    const { relationship } = this.props;
    const uid = `relationship-${relId}-${propKey}`;

    if (
      val &&
      typeof val.has === 'function' &&
      val.has('_type') &&
      val.get('_display') !== false
    ) {
      const fieldValue = relationship.hasIn(['props', propKey])
        ? relationship.getIn(['props', propKey], '')
        : val.get('_default');
      const customHelpText = val.get('_helptext', null);
      const typeOptions = val.get('_typeOptions')
        ? val.get('_typeOptions').toJSON()
        : null;
      const propType = val.get('_type');
      const TypeComponent = getComponent(propType);

      const propertyTypeEditor = TypeComponent
        ? <InlineEditor
            key={`${propKey}-${index}`}
            component={TypeComponent}
            propertyKey={propKey}
            value={fieldValue}
            form={uid}
            inlineTypeOptions={typeOptions}
            customHelpText={customHelpText}
            onSave={this.updateRelationshipPropValue}
            currentRelationshipId={relId}
            fieldIndex={index}
          />
        : null;

      if (propKey === 'Assumption') {
        return (
          <div key={`fg-${propKey}-${index}`} className="form-group mb-2">
            <label className="col-form-label" style={{ padding: 0 }}>
              Tearing
            </label>
            <div>{propertyTypeEditor}</div>
          </div>
        );
      } else {
        return (
          <div key={`fg-${propKey}-${index}`} className="form-group row mb-2">
            <label className="col-sm-3 col-form-label" style={{ padding: 0 }}>
              {propKey}
            </label>
            <div className="col-sm-9">{propertyTypeEditor}</div>
          </div>
        );
      }
    }

    return <div key={index} />;
  };

  buildProperties = () => {
    const { relationship, relationshipTypes } = this.props;
    const properties = relationshipTypes.getIn([relationship.get('type_id'), 'props'], List());
    const relId = relationship.get('id');
    let index = 1;

    return (
      <div className="relationship-props">
        {properties.reduce(
          (prev, prop, propKey) =>
            prev.push(this.fieldSet(propKey, prop, relId, index++)),
          List(),
        )}
      </div>
    );
  };

  render() {
    return (
      <div>
        {this.buildProperties()}
      </div>
    );
  }
}

export default class Relationship extends Component {
  static propTypes = {
    relationship: PropTypes.instanceOf(Map),
    elements: PropTypes.instanceOf(Map),
    selectElement: PropTypes.func,
  };

  _closePanel = () => {
    const {
      selectElement,
    } = this.props;

    // TODO: Fix this
    selectElement(-1);
  };

  render() {
    const {
      relationship,
      elements,
    } = this.props;

    return (
      <div className="tab-content">
        <div className="elementTitle" style={{ position: 'relative' }}>
          <div style={{ float: 'right', marginTop: -5 }}>
            <i
              onClick={this._closePanel}
              className="fa fa fa-times fa-2x"
              style={{ verticalAlign: 'middle' }}
            />
          </div>
          <h2>
            {elements.getIn([relationship.get('producer'), 'name'])}
            {' '}
            <i className="fa fa-long-arrow-right" aria-hidden="true" />
            {' '}
            {elements.getIn([relationship.get('consumer'), 'name'])}
          </h2>
          <hr />
        </div>
        <RelationshipProps {...this.props} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RightColumn/Relationship/Relationship.js